import axios from "axios";
import { urlDomain } from "../config/constant";

const apiDomain = urlDomain();
export const rabbitMQPubAPi = (requestData) => {
    const apiUrl = `${apiDomain}/dataDump`;
    return axios.post(apiUrl, requestData)
}